import { Session } from "./global";
import { setAnalyticsId } from "./gtag";
import { setAnonymousId } from "./segmentio";

/**
 * Restores analytics IDs from app state after OAuth redirect or from query parameters.
 * @param params
 */
export function restore(params: Session): void {
  // Restore analytics IDs from app state after OAuth redirect
  if (params.anonymousId) {
    setAnonymousId(params.anonymousId);
  }

  if (params.gaClientId && params.gaSessionId) {
    setAnalyticsId(params.gaClientId, params.gaSessionId);
  }
}
